import { NgForOf, NgIf } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { PortalFieldTypeConfig } from '@portal/form/data-access';
import { UsPersonModel } from '@portal/application/data-access';

@Component({
  selector: 'portal-application-array-us-person',
  standalone: true,
  imports: [FormlyModule, ReactiveFormsModule, MatIconModule, NgIf, NgForOf],
  template: `
    <div class="mb-3">
      <legend *ngIf="props.label">{{ props.label }}</legend>
      <p *ngIf="props.description">{{ props.description }}</p>

      <div *ngFor="let f of field.fieldGroup; let i = index">
        <div class="flex justify-between">
          <p class="text-turquoise font-bold portal-paragraph">Particulars of US Person #{{ i + 1 }}</p>
          <button
            *ngIf="!disabled"
            type="button"
            (click)="remove(i)"
          >
            <mat-icon
              class="icon-size-5 text-primary"
              svgIcon="recycle_bin"
            >
            </mat-icon>
          </button>
        </div>
        <formly-field
          class="col"
          [field]="f"
        ></formly-field>
      </div>
      <div class="flex">
        <button
          *ngIf="!disabled"
          class="btn btn-primary flex gap-2 ms-auto"
          type="button"
          (click)="add()"
        >
          <span class="font-bold">Add Another Shareholder</span>
          <span class="flex items-center justify-center">
            <mat-icon class="field-file-prefix text-green">add_circle_outline</mat-icon>
          </span>
        </button>
      </div>

      <formly-validation-message
        *ngIf="showError"
        class="block text-xs text-primary mt-1"
        [field]="field"
      ></formly-validation-message>
    </div>
  `,
})
export class FormArrayUsPersonComponent extends FieldArrayType<PortalFieldTypeConfig> implements OnInit {
  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }

  override add(): void {
    super.add(undefined, UsPersonModel.createEmpty());
  }

  ngOnInit(): void {
    this.field.props.add = this.add.bind(this);
    this.field.props.remove = this.remove.bind(this);
  }
}

@NgModule({
  imports: [
    FormlyModule.forChild({
      types: [{ name: 'form-array-us-person', component: FormArrayUsPersonComponent }],
    }),
  ],
})
export class FormArrayUsPersonModule {}
